// extracted by mini-css-extract-plugin
module.exports = {"mixed":"MixedIngredients_mixed__2lodF"};